/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Enumeration of dashboard summary aggregation types.
 */
export enum DashboardSummaryType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}
